export const DATA_BOOKMARKS_FETCH = 'DATA_BOOKMARKS_FETCH';
export const DATA_BOOKMARKS_ADD = 'DATA_BOOKMARKS_ADD';
export const DATA_BOOKMARKS_REMOVE = 'DATA_BOOKMARKS_REMOVE';
export const DATA_BOOKMARKS_UPDATE = 'DATA_BOOKMARKS_UPDATE';
